import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        // Skip scroll on home page
        if (event.urlAfterRedirects === '/' || event.urlAfterRedirects === '') {
          return;
        }
        
        // 1. Instantly reset scroll to top so the new page doesn't inherit previous scroll state
        window.scrollTo(0, 0);

        // 2. Smoothly slide down to the actual content area after component paints
        setTimeout(() => {
          this.smoothScrollToContent();
        }, 120);
      });
  }

  // Keep onActivate as a no-op so the template binding still works
  onActivate(_event: any): void {}

  private smoothScrollToContent(): void {
    // Request animation frame to ensure layout calculations and scroll happen on a clean paint cycle
    requestAnimationFrame(() => {
      // Prioritize the actual page content area, fall back to next sibling of banner, then top of page
      const contentTarget =
        document.querySelector('.content-box') ||
        document.querySelector('app-banner + *') ||
        document.querySelector('.content-col') ||
        document.querySelector('.inner-page') ||
        document.querySelector('main') ||
        document.body;

      if (!contentTarget || contentTarget === document.body) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      const headerEl = document.querySelector('#header') as HTMLElement;
      const headerHeight = headerEl ? headerEl.offsetHeight : 100;

      const elementTop = contentTarget.getBoundingClientRect().top + window.pageYOffset;
      const scrollTo = elementTop - headerHeight - 20; // 20px breathing room

      window.scrollTo({
        top: Math.max(0, scrollTo),
        behavior: 'smooth'
      });
    });
  }
}
